import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL_DEV,
});

export const createRetreat = (data) =>
  API.post("/app/retreats", data);

export const getRetreats = () =>
  API.get("/app/retreats");

export const getRetreatById = (id) =>
  API.get(`/app/retreats/${id}`);

export const updateRetreat = (id, data) =>
  API.put(`/app/retreats/${id}`, data);

export const deleteRetreat = (id) =>
  API.delete(`/app/retreats/${id}`);